import * as yup from "yup";

export const sendMessageSchema = yup.object({
	category: yup.string().required("Category is required"),
	title: yup.string().required("problem is required"),
	message: yup.string().required("Message is required")
});
